import { useState } from "react";

const lensesData = [
  {
    title: "Anti-Glare Lenses",
    img: "/images/lenses/antiglare.jpg",
    best: true,
  },
  {
    title: "Blue-Cut Lenses",
    img: "/images/lenses/bluecut.jpg",
    best: true,
  },
  {
    title: "Photochromic Lenses",
    img: "/images/lenses/photochromic.jpg",
    best: false,
  },
  {
    title: "Progressive Lenses",
    img: "/images/lenses/progressive.jpg",
    best: false,
  },
];

const BrandedLenses = () => {
  const [activeImage, setActiveImage] = useState(null);

  return (
    <section className="section">
      <div className="container">
        <h2>Branded Lenses</h2>
        <p className="section-subtitle">
          Clear, comfortable and trusted lenses for everyday vision.
        </p>

        <div className="grid">
          {lensesData.map((item, index) => (
            <div className="card image-card" key={index}>
              {item.best && <span className="badge">Best Seller</span>}

              <img
                src={item.img}
                alt={item.title}
                className="service-image clickable"
                onClick={() => setActiveImage(item.img)}
              />

              <h3>{item.title}</h3>
            </div>
          ))}
        </div>
      </div>

      {activeImage && (
        <div className="lightbox" onClick={() => setActiveImage(null)}>
          <img src={activeImage} alt="Preview" />
          <span className="close">×</span>
        </div>
      )}
    </section>
  );
};

export default BrandedLenses;
